// pdf.js 6 calls Map#getOrInsertComputed. Chrome Android WebView 143 does not
// implement it, so OmmnioSign PDF pages throw before the first paint (OMMNIO-WEB-19).

const { prototype } = Map;

if (typeof prototype.getOrInsert !== 'function') {
  Object.defineProperty(prototype, 'getOrInsert', {
    configurable: true,
    writable: true,
    value(key, value) {
      if (this.has(key)) {
        return this.get(key);
      }
      this.set(key, value);
      return value;
    },
  });
}

if (typeof prototype.getOrInsertComputed !== 'function') {
  Object.defineProperty(prototype, 'getOrInsertComputed', {
    configurable: true,
    writable: true,
    value(key, callbackfn) {
      if (this.has(key)) {
        return this.get(key);
      }
      const value = callbackfn(key);
      this.set(key, value);
      return value;
    },
  });
}
